import * as Yup from 'yup';

export const loadQrCodeValidationSchema = Yup.object().shape({
  qrCode: Yup.string(),
});
